import { render, staticRenderFns } from "./message-list.html?vue&type=template&id=7c7d00d0&scoped=true&"
import script from "./message-list.js?vue&type=script&lang=js&"
export * from "./message-list.js?vue&type=script&lang=js&"
import style0 from "./message-list.scss?vue&type=style&index=0&id=7c7d00d0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7d00d0",
  null
  
)

export default component.exports